import { Component, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';

@Component({
    selector: 'app-becas',
    templateUrl: './becas.component.html',
    styles: [],
    standalone: true,
    imports: [ CarouselComponent]
})
export class BecasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
